import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DbStatus } from '@/types/api';
import { DB_STATUS_COLORS, dbStatusLabelKey } from '@/utils/dbStatus';

interface DbStatusIndicatorProps {
  status: DbStatus;
  size?: number;
}

const DbStatusIndicator: React.FC<DbStatusIndicatorProps> = ({ status, size = 10 }) => {
  const { t } = useTranslation('pages');

  return (
    <Tooltip title={t(dbStatusLabelKey(status))}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: DB_STATUS_COLORS[status],
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
};

export default DbStatusIndicator;
